<template>
  <v-row
    class="ticket-show"
  >
    <v-col
      cols="12"
    >
      <v-card
        class="ticket-show-actions"
        elevation="2"
        :loading="isLoading"
        outlined
        tile
      >
        <v-card-title>
          {{ settlementPageTitle }}
        </v-card-title>
        <v-card-text
          v-if="!isLoading"
        >
          <DisplayLatestSettlementPlan
            v-if="latestSingleSettlement"
            settlement-type="single_payment_plan"
            :model-data="latestSingleSettlement"
            :ticket="ticket"
          />

          <DisplayLatestSettlementPlan
            v-else-if="latestReducedPayoffPlan"
            settlement-type="reduced_payoff_plan"
            :model-data="latestReducedPayoffPlan"
            :ticket="ticket"
          />

          <CreateSinglePaymentPlan
            v-else-if="showSinglePaymentOption"
            :min-settlement-amount="minSettlementAmount"
            :max-settlement-amount="maxSettlementAmount"
            :payment-accounts="paymentAccounts"
            :loan-id="ticket.active_loan.id"
            :ticket="ticket"
            @display-settlement-final-actions="displayTicketActions = true"
            @display-reduced-payoff-plan-option-view="displayReducedPayoffPlanComponent"
          />
          <CreateReducedPayoffPlan
            v-else-if="showReducedPayoffPlanOption"
            :payment-accounts="paymentAccounts"
            :loan-id="ticket.active_loan.id"
            :ticket="ticket"
            :first-payment-date-in-plan="firstPaymentDate"
            :payoff-plan-options="reducedPayoffPlanOptions"
            @display-single-payment-option-view="displaySinglePaymentOptionComponent"
            @display-settlement-final-actions="displayTicketActions = true"
          />
          <SettlementOptions
            v-else
            :today-payoff-balance="todayPayoffBalance"
            :is-valid-settlement-status="isSettlementAvailable"
            @display-single-payment-option-view="displaySinglePaymentOptionComponent"
            @display-reduced-payoff-plan-option-view="displayReducedPayoffPlanComponent"
          />
        </v-card-text>
      </v-card>
      <!--ticket action -  resolve ticket and do another action-->
      <v-dialog
        v-model="displayTicketActions"
        width="400px"
        persistent
      >
        <v-card>
          <v-card-title>
            Alert
          </v-card-title>
          <v-card-text>
            Would you like to resolve the ticket or carry out another action?
          </v-card-text>
          <v-divider />
          <ticket-actions />
        </v-card>
      </v-dialog>
      <!--End ticket action -  resolve ticket and do another action-->
    </v-col>
  </v-row>
</template>

<script>

import { mapState, mapActions } from 'vuex';

import SettlementOptions from '@/views/Tickets/PdsSettlement/SettlementOptions.vue';
import CreateSinglePaymentPlan from '@/views/Tickets/PdsSettlement/CreateSinglePaymentPlan.vue';
import CreateReducedPayoffPlan from '@/views/Tickets/PdsSettlement/CreateReducedPayoffPlan.vue';
import DisplayLatestSettlementPlan from '@/views/Tickets/PdsSettlement/DisplayLatestSettlementPlan.vue';
import TicketActions from './TicketActions.vue';

export default {
  name: 'TicketPdsSettlement',
  components: {
    DisplayLatestSettlementPlan,
    CreateSinglePaymentPlan,
    SettlementOptions,
    CreateReducedPayoffPlan,
    TicketActions,
  },

  data() {
    return {
      ticket: {},
      isLoading: true,
      displayTicketActions: false,
      showPayFullBalance: false,
      showSettlementOffer: false,
      showSinglePaymentOption: false,
      subHeaderText: '',
      showReducedPayoffPlanOption: false,
      isCovidCollection: false,
      todayPayoffBalance: null,
      loanSettingsId: null,
      paymentAccounts: {},
      fullName: null,
      displayId: null,
      loanData: {
        payoff: 0,
        dueInterest: 0,
        principalBalance: 0,
      },
    };
  },

  computed: {
    ...mapState('settlement', [
      'isSettlementAvailable',
      'minSettlementAmount',
      'maxSettlementAmount',
      'reducedPayoffPlanOptions',
      'firstPaymentDate',
      'latestReducedPayoffPlan',
      'latestSingleSettlement',
    ]),

    settlementPageTitle() {
      return `Settlement${this.subHeaderText ? ` - ${this.subHeaderText}` : ''}`;
    },
  },

  async created() {
    await this.getTicket();

    await this.initializeSettlement({
      ticketId: this.ticket.zendesk.id,
      lpLoan: this.ticket.active_loan.id,
    });

    await this.getPaymentProfiles();

    this.todayPayoffBalance = this.ticket.active_loan.current_status.payoff;
    this.isLoading = false;
  },

  methods: {
    ...mapActions('settlement', ['initializeSettlement', 'determineAvailability']),

    async reloadPaymentProfiles() {
      await this.getPaymentProfiles();
    },

    async getTicket() {
      this.loadingModel = true;

      const res = await this.$axios
        .post('api/v1/support/ticket', {
          ticketId: this.$route.params.id,
        });

      this.ticket = res.data.data;
    },

    async getPaymentProfiles() {
      const res = await this.$axios
        .post(`api/v1/loanpro-customer/${this.ticket.lpCustomer.id}/payment-profiles`, {
          ticketId: this.$route.params.id,
        });

      this.paymentAccounts = [...res.data.data];
    },

    displayReducedPayoffPlanComponent() {
      this.showReducedPayoffPlanOption = true;
      this.showSinglePaymentOption = false;
      this.subHeaderText = 'Reduced Payoff Plan Option';
    },

    displaySinglePaymentOptionComponent() {
      this.showSinglePaymentOption = true;
      this.showReducedPayoffPlanOption = false;
      this.subHeaderText = 'Single Payment Option';
    },
  },
};
</script>
